import React, { useState ,useContext} from "react";
import { createCommentRequest} from '../api/form.api'
import { DbContext} from './DbContextProvider'

export const useDb = ( ) => {
      const context = useContext(DbContext)
      if (!context) {
        throw new Error("Contexto Sin Fragment");
      } 
      return context
}

export const DbContextProvider = (props) => {
  const [textos, setTextos] = useState([])
  async function loadComment(){
     try {
        setTextos([{id: 1, user: 'Dromm Name', comment: 'Exelent Up!!!', createAt: '2025-11-25T23:07:29.000Z'}])    
      } catch (error) {
        setTextos([{id: 1, user: 'Dromm Name', comment: 'Exelent Up!!!', createAt: '2025-11-25T23:07:29.000Z'}])
      }
    }
  const createdComment = async (values) =>{
    await createCommentRequest(values);
  }  
  return (
    <DbContext.Provider
      value={{ textos , loadComment , createdComment}}
    >{props.children}
    </DbContext.Provider>
  );
}
